/*!
 * Copyright © 2020-2022. Verizon Connect Ireland Limited. All rights reserved.
 */

export enum EPendoCustomEvents {
  ShowBalloon = 'Show_balloon',
  ClusteringEnabled = 'Clustering_enabled',
  ClusteringDefaultThresholdExceeded = 'Clustering_default_threshold_exceeded',
  LossOfSignal = 'Loss_of_signal',
  LiveMapBalloonWithDeviceIssue = 'LiveMap_Balloon_With_Device_Issue',
  ManagePostedSpeedClickedByMenu = 'Click-Context Menu > Manage posted speed',
  ManagePostedSpeedClickedByBalloon = 'Click-Replay Balloon > Manage posted speed',
  ManagePostedSpeedRoadDetailsCard = 'ManagePostedSpeed_RoadDetailsCard',
  FilterPanelOpened = 'FilterPanelOpened',
  AttributeFilterApplied = 'AttributeFilterApplied',
  ManagePostedSpeedSaveOverrideSuccess = 'ManagePostedSpeed_SaveOverrideSuccess',
  ManagePostedSpeedSaveOverrideFailure = 'ManagePostedSpeed_SaveOverrideFailure',
  ManagePostedSpeedOverrideErrorEncountered = 'ManagePostedSpeed_OverrideErrorEncountered',
  LiveMapContextMenuOpened = 'LiveMap_ContextMenu_Opened',
  EmptyFilterResultsShown = 'EmptyFilterResultsShown'
}
